<template>
  <h3 class="lg:text-[44px] text-[31px] text-center font-bold lg:px-10">
    <WrGradientText
      :text="heading"
      append-class="pb-0 lg:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-1.57%,_var(--text-gradient-2)_30.72%)]"
    />
  </h3>
  <p class="mt-4 text-lg text-center">
    {{ subheading }}
  </p>
  <div class="mt-5 flex flex-col items-start w-full justify-between">
    <div
      class="w-full flex flex-col justify-between items-stretch overflow-hidden relative bg-[#7957d5] text-[#fff] rounded-[10px]  bg-no-repeat bg-cover h-full p-[4.875rem_1.25rem_5.625rem] before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-[#5f4ca4] before:opacity-75 before:block z-10"
    >
     <NuxtImg
          src="/images/services-cta-top.webp"
          loading="lazy"
          background
          fill
          class="absolute inset-0 w-full h-full object-cover object-center z-0"
          />
      <h3 class="text-white text-[44px] relative z-10 font-bold">
        Who are we?
      </h3>
      <p
        v-for="(text, idx) in content"
        :key="idx"
        class="text-lg text-white max-sm:mt-5 lg:w-[70%] relative z-10 mt-10"
      >
        {{ text }}
      </p>
    </div>
    <div class="grid grid-cols-3 max-lg:grid-cols-2 max-xl:gap-3 w-full mt-4 lg:mt-10">
        <div v-for="card in whoAreWeCards"
          class=" relative items-stretch overflow-hidden w-full xl:max-w-[400px] flex flex-col bg-no-repeat bg-[length:100%] h-full rounded-[10px] bg-[#5f4ca4] text-[#fff] before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-[#5f4ca4] before:opacity-75 before:block z-10 lg:p-[4.875rem_1.25rem_5.625rem] p-[1rem_1.5rem]"
         
        >
          <NuxtImg
          :src="card.image"
          loading="lazy"
          background
          fill
          class="absolute inset-0 w-full h-full object-cover object-center z-0"
          />
          <h3 class="text-white text-[44px] relative z-10 font-bold">
            {{ card.heading }}
          </h3>
          <p class="text-lg text-white mt-5 w-[70%] relative z-10">
            {{ card.text }}
          </p>
        </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  heading: {
    type: String,
    required: true,
  },
  subheading: {
    type: String,
    required: true,
  },
  content: {
    type: Array,
    required: true,
  },
  whoAreWeCards: {
    type: Array,
    default: [
      {
        image: "/images/service-business.webp",
        heading: "10+",
        text: "Years in Business",
      },
      {
        image: "/images/service-projects.webp",
        heading: "90+",
        text: "Successful Projects",
      },
      {
        image: "/images/service-team.webp",
        heading: "150+",
        text: "In-House Talents",
      },
    ],
  },
});
</script>

<style lang="scss" scoped></style>
